export default __webpack_public_path__ + "static/media/instagramIcon.71e72694.svg";